import React from "react";
import LazyLoad from "react-lazyload";
const sxs2026_committee = [
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-1.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-2.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-3.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-4.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-5.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-6.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-7.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-8.jpeg",
];
function MUN2026() {
  return (
    <div class="col-12 row">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <article>
          <LazyLoad>
            
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/manager.jpg"
              alt="St. Xavier’s School Bathinda"
              class="sxumn_2021_msg img-fluid"
            />
          </LazyLoad>
          <h3>Rev. Fr. Manager's Message</h3>
          <p>
            “O judgment! thou art fled to brutish beasts, and men have lost
            their reason.”
            <br />
            —William Shakespeare
            <br />
            (Julius Caesar)
          </p>
          <p>Dear Delegates, Faculty and Guests,</p>
          <p>
            The cutting satire drawn from Julius Caesar echoes through the
            international political aisles, raising the alarm against global
            diplomacy failures and their horrendous ramifications. The
            international map has been brutally torn into warzones and arbitrary
            political abductions, deadly blockades around the Pacific and Gulf
            nations have fractured the global order.
          </p>
          <p>
            As our global community wades through a welter of conflicting
            ideologies and crises of reason, the world looks to the educational
            sector to prepare the next generation with the robust ideals of
            ethical humanism. St. Xavier&apos;s school, Bathinda, solemnly
            upholds this responsibility and takes immense pride in launching the
            10th edition of SXMUN to inspire ethical international unison.This
            simulation is an entreaty to reclaim &apos;reason&apos; and
            &apos;judgment&apos;, entailing peace and harmony.
          </p>
          <p>
            To contain the savage impulse, a revolution guided by prudent
            leadership is called for. SXMUN invites young
            diplomats-in-the-making to devise a blueprint sketching a plan to
            combat complicated global crises, not with hostility, but with
            synergy and cohesive strategies. May the Muse of Judgment empower
            your deliberations, dialogues and debates with logic, moving the
            conclave towards impeccable peace.
          </p>
          <p>Warm regards,</p>
          <p>
            Rev. Fr. Eusebio Gomes
            <br />
            Manager
            <br />
            St. Xavier&apos;s School, Bathinda
          </p>
          <div class="clr"></div>
        </article>
        <div class="clr"></div>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <article>
          <LazyLoad>
            
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-principal.JPG"
              alt="St. Xavier’s School Bathinda"
              class="sxumn_2021_msg img-fluid"
            />
          </LazyLoad>
          <h3>Rev. Fr. Principal's Message</h3>
          <p>
            “How dull it is to pause, to make an end,
            <br />
            To rust unburnish&apos;d, not to shine in use!”
            <br />
            — Tennyson
            <br />
            (Julius Caesar)
          </p>
          <p>Dear Delegates, Faculty and Members of the Secretariat,</p>
          <p>
            While war is immoral to pacifists, it is non-moral to realists. The
            ongoing debates surrounding this issue often raise rhetoric against
            the moral relationships between nations, while discussions on the
            consequential economic burden on taxpayers frequently crash into
            mere conjecture. To answer and conclude this oblivious commotion,
            SXMUN Edition X propagates the theme of &apos;Unus Mundus&apos; –
            One World, One Dialogue and a Shared Future.
          </p>
          <p>
            As value education does not take place in isolation, it requires a
            contextual setting of the actual world we live in. The Xaverian
            spirit aligns seamlessly with the objective of building calibre
            based on working knowledge against formidable challenges. SXMUN–
            Edition X is all set to assemble the best intellectual talent in a
            simulation of an international consortium, aiming to uphold the
            value of shared interests while challenging the neo-colonial order.
          </p>
          <p>
            St. Xavier&apos;s academia takes pride in witnessing classrooms turn
            into the Security Council, wherein 15-year-olds, powered by
            cognitive abilities, demonstrate inspiring resilience. They ride the
            troughs and peaks of a long-drawn-out series of deliberations,
            culminating in the final drafting of resolutions. The decennial
            acknowledges the celebratory validation of incessant empirical
            discourse, clubbed with the meritorious administrative skills
            demonstrated by the Secretariat and Organizing Committee for ten
            glorious years.
          </p>
          <p>
            In an effort to replenish the ethical capital currently being eroded
            by acts of commission and omission in executing the United Nations
            charter and by the abuse of power afflicting the international
            order, SXMUN – Edition X, in compliance with the theories of
            consequentialism, deontology and virtue ethics, is set to unearth
            the complex relationship between morality and international
            diplomacy. The simulation augments the inevitable discussion on
            humanitarian intervention, exploring membership in international
            agencies like NATO and the justification of sanctions to expose
            suspicious, self-serving agendas.
          </p>
          <p>
            It is the Xaverian austere pursuit to expose the bloody business of
            conflict, where a severed carotid artery sends jitters down
            one&apos;s spine and where the aftermath leaves behind orphans,
            widows, the homeless and the starving, with epidemics filling graves
            faster than the war itself.
          </p>
          <p>Uphold the cause of humanity!</p>
          <p>Warm regards,</p>
          <p>
            Rev. Fr. Cidloy Furtado
            <br />
            Principal
            <br />
            St. Xavier&apos;s School, Bathinda
          </p>
          <div class="clr"></div>
        </article>
        <div class="clr"></div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <article>
          <h3>Message by Secretary General</h3>

          <p>
            “Individually, we are one drop.
            <br />
            Together, we are an ocean.” <b>— Ryunosuke Satoro</b>
          </p>

          <p>
            <b>Greetings everyone,</b>
          </p>

          <p>
            As we stand in a world that has endured suffering, distress and
            uncertainty, one often ponders, ‘WHAT COMES NEXT? WILL PEACE EVER
            RETURN?’ These questions still echo in the minds of youth who are
            uncertain and anxious about the coming future. Yet, in moments of
            fear and anxiety, hope persists—a hope to change, to rise and to
            act.
          </p>

          <p>
            This year, SXMUN&apos;s theme is not merely a theme but a call to
            rise and make a difference—DECENNIAL: DECADE OF DISCOURSE – UNUS
            MUNDUS. For ten years, SXMUN has stood as more than just a
            conference. It has served as a platform where perspectives are
            examined and constructive dialogue plays a crucial role in shaping
            the leaders of tomorrow. It marks a decade of diplomacy and
            discussion, where young minds have come together to address the
            pressing issues humanity is facing today.
          </p>

          <p>
            UNUS MUNDUS—a call for one world. A world that is connected despite
            its differences, a world with a shared vision and a world with a
            common cause. Let SXMUN be a platform for shared visions and ideas,
            where opinions transform into action.
          </p>

          <p>
            The wait is over. Let the vision of UNUS MUNDUS lead us towards
            unity.
          </p>

          <p>
            <strong>Warm Regards,</strong>
            <br />
            <br />
            Sanchita Goyal
            <br />
            Secretary General, SXMUN 2026
          </p>

          <div className="clr"></div>
        </article>

        <div className="clr"></div>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <article>
          <h3>Message by Deputy Secretary-General</h3>
          <p>
            “The revolution is not an apple that falls when it is ripe.
            <br />
            You have to make it fall.” <b>— Che Guevara</b>
          </p>
          <p>
            <b>Dear Delegates,</b>
          </p>
          <p>
            It is with immense pride and honour that I welcome you to the 10th
            Edition of our Model United Nations Conference—a landmark
            celebration of a decade of diplomacy, dialogue and excellence.
          </p>
          <p>
            Over the past ten editions, this conference has grown into more than
            just an event; it has become a legacy that has empowered young
            leaders to think critically, speak confidently and lead with
            integrity. As we celebrate this remarkable journey, we also look
            ahead to the future that each one of you has the potential to
            shape.
          </p>
          <p>
            As you step into your committees, remember that true diplomacy is
            not about winning arguments but about building understanding. Speak
            with confidence, listen with respect and negotiate with purpose. Let
            every debate challenge your perspective, every resolution reflect
            your vision and every interaction strengthen your character.
          </p>
          <p>
            Whether this is your first MUN or your tenth, I encourage you to
            embrace every opportunity to learn, collaborate and grow. The
            experiences you gain here will extend far beyond the committee
            room.
          </p>
          <p>
            On behalf of the Secretariat, I warmly welcome you to this historic
            edition. May this conference inspire meaningful debate, lasting
            friendships and a shared commitment to creating a better future.
          </p>
          <p>
            <strong>Warm Regards,</strong>
            <br />
            Mayur Garg
            <br />
            Deputy Secretary-General
          </p>
          <div class="clr"></div>
        </article>

        <div class="clr"></div>
      </div>

         <div className="sxmun_img_sec_new row">
                <center>
                  <h2>Committees and Agendas for SXMUN 2025 </h2>
                </center>
                {sxs2026_committee.map(function(item,index,arr){
                  return(
                    <>

                       <div className="col-12 col-sm-12 col-md-6 col-lg-4 mx-auto d-block">
                  
                  <img
                    src={item}
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                    </>
                  )
                })}
              </div>
    </div>
  );
}

export default MUN2026;
